__webpack_require__.p = "https://pwa.ludosupreme.com/";